export enum SicalcUserRole {
  Administrator = "Administrator",
  AvinorUser = "AvinorUser",
  ForsvarsbyggUser = "ForsvarsbyggUser",
  IsaviaUser = "IsaviaUser",
  Consultant = "Consultant",
  Approver = "Approver",
}

export const sicalcUserRoleLabels: Record<SicalcUserRole, string> = {
  [SicalcUserRole.Administrator]: "Administrator",
  [SicalcUserRole.AvinorUser]: "Avinor-bruker",
  [SicalcUserRole.ForsvarsbyggUser]: "Forsvarsbygg-bruker",
  [SicalcUserRole.IsaviaUser]: "Isavia-bruker",
  [SicalcUserRole.Consultant]: "Konsulent",
  [SicalcUserRole.Approver]: "Kvalitetssikrer",
}

export const getSicalcUserRoleLabel = (role: string) =>
  sicalcUserRoleLabels[role as SicalcUserRole] ?? role
